import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { filter, first, skip, take, takeUntil } from 'rxjs';
import { SaleHorseSetting } from 'src/app/models/sales/sale-horse-settings.model';
import { SaleHorse } from 'src/app/models/sales/sale-horse.model';
import { Sale } from 'src/app/models/sales/sales.model';
import { AuthService } from 'src/app/services/auth.service';
import { HttpErrorHandlerService } from 'src/app/services/http-error-handler.service';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ViewMode } from 'src/app/shared-new/enums/view-mode.emun';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { SalesFacade } from 'src/app/shared-new/store/sales/sales.facade';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';
import { MemberAccess } from '../../../../models/common/member-access.model';
import { StudyDicomInfo } from '../../../../models/Study/study.model';

@Component({
  selector: 'app-edit-study',
  templateUrl: './edit-study.component.html',
  styleUrls: ['./edit-study.component.scss'],
})
export class EditStudyComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() saleId: number = 0;
  @Input() horseId: number = 0;
  @Input() studyId: number = 0;
  @Input() saleName: string = '';
  @Input() horseName: string = '';

  @Input() lot: string = '';
  @Input() tabStatus: any;
  @Output() closedClicked = new EventEmitter();
  @Output() onChangeTab = new EventEmitter<any>();

  activeStudyStatusId$ = this.studyFacade.activeStudyStatusId$;
  activeSaleHorseStudy$ = this.studyFacade.activeSaleHorseStudy$;
  mediaGroups$ = this.studyFacade.mediaGroups$;
  mediaCategories$ = this.studyFacade.mediaCategories$;
  missingMediaCategories$ = this.studyFacade.missingMediaCategories$;
  //tabStatus$ = this.studyFacade.tabStatus$;
  studyStatusError$ = this.studyFacade.studyStatusError$;
  studyStatusSuccess$ = this.studyFacade.studyStatusSuccess$;
  saleSettings$ = this.studyFacade.saleHorseSettings$;
  saleMemberAccess$ = this.saleFacade.saleMemberAccess$;
  isLoading$ = this.studyFacade.isLoading$;
  saleSettings: SaleHorseSetting;
  viewMode: ViewMode = ViewMode.DRAFT;
  ViewMode = ViewMode;
  horse: SaleHorse = null;
  sale: Sale = null;

  isViewerOnly: boolean = false;
  isViewXraysAllowed: boolean = false;
  viewXrayValidationMessage: string = '';

  isUserSaleEditor: boolean = false;
  isUserHasUploadAccess: boolean = false;
  calledMemberAccess = false;
  hasSaleSettings = false;
  autoApproveSubmissions = false;
  @Input() public catalogDataSource: StudyDicomInfo[] = [];
  @Input() public lotOrHipText: string = '';
  public disclosedClient : string = '';
  constructor(
    private studyFacade: StudiesFacade,
    private authService: AuthService,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private toastService: ToastService,
    private saleFacade: SalesFacade
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadData();
    // this.updateTabStatus(); // Remove this if not needed initially

    // Call updateTabStatus only on first emission
    this.saleMemberAccess$
      .pipe(
        filter((m) => !!m),
        take(1)
      )
      .subscribe((memberAccess) => {
        this.setMemberAccess(memberAccess);
        // Call it only once here
        this.updateTabStatus();
      });

    this.saleMemberAccess$
      .pipe(
        filter((m) => !!m),
        skip(1), // skip the first emission
        takeUntil(this.unsubscribe$)
      )
      .subscribe((memberAccess) => {
        this.setMemberAccess(memberAccess);
      });

    this.saleSettings$
      .pipe(
        first((ss) => !!ss),
        take(1)
      )
      .subscribe((saleSettings) => {
        this.saleSettings = saleSettings;
        this.autoApproveSubmissions = !!this.saleSettings.saleSubmission.find(
          (s) => !!s.isAutoApproveSubmissions
        );
      });
  }

  private setMemberAccess(memberAccess: MemberAccess) {
    this.isUserSaleEditor = memberAccess.isSalesEditor;
    this.isUserHasUploadAccess = memberAccess.isSubmitAccess;

    this.isViewerOnly =
      memberAccess.isViewOnly && !memberAccess.isSubmitAccess;

    this.isViewXraysAllowed = memberAccess.isViewXraysAllowed;

    this.viewXrayValidationMessage = memberAccess.validationMessage;
  }
  public disclosedClientChanged(disclosedClientName: string){
    this.disclosedClient = disclosedClientName;
  }
  private updateTabStatus() {

    if (this.isViewerOnly) {
      this.setViewMode(ViewMode.APPROVED);
    } else if (this.tabStatus.landOnApprovedTab) {
      this.setViewMode(ViewMode.APPROVED);
    } else if (this.tabStatus.landOnReviewTab) {
      this.setViewMode(ViewMode.IN_REVIEW);
    } else if (this.tabStatus.landOnUploadTab && this.isUserHasUploadAccess) {
      this.setViewMode(ViewMode.UPLOAD);
    } else if (!this.isUserHasUploadAccess) {
      this.setViewMode(ViewMode.APPROVED);
    }
    else {
      if (this.isUserHasUploadAccess) {
        this.setViewMode(ViewMode.DRAFT);
      } else {
        this.setViewMode(ViewMode.IN_REVIEW);
      }
    }

  }

  private attachEvents() {
    this.studyStatusError$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((err) => {
        if (err) {
          this.studyFacade.clearStudyStatus();
          //this.httpErrorHandlerService.ShowErrorMessage(err);
        }
      });

    this.studyStatusSuccess$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (response) {
          // this.toastService.success('Study has been successfully submitted');

          setTimeout(() => {
            if (this.studyId) {
              this.updateTabStatus();
            }
          }, 1000);
          this.studyFacade.clearStudyStatus();
        }
      });
  }

  // private async loadSaleMemberAccessData() {
  //   let memberAccessData: MemberAccess;
  //   if (this.saleId) {
  //     memberAccessData = await this.authService.getSaleMemberAccessData(
  //       this.saleId
  //     );
  //     this.isUserSaleEditor = memberAccessData.isSalesEditor;
  //     this.isUserHasUploadAccess = memberAccessData.isSubmitAccess;
  //     this.isVetEditor =
  //       memberAccessData.isSubmitAccess;
  //       this.isViewerOnly =
  //       memberAccessData.isViewOnly && !memberAccessData.isSubmitAccess;
  //     this.loadData();
  //   } else {
  //     this.authService
  //       .getMemberAccessData(this.saleId)
  //       .pipe(take(1))
  //       .subscribe((accessDataResponse) => {
  //         memberAccessData = accessDataResponse;
  //         this.isUserSaleEditor = memberAccessData.isSalesEditor;
  //         this.isUserHasUploadAccess = memberAccessData.isSubmitAccess;
  //         this.isVetEditor =
  //       memberAccessData.isSubmitAccess;
  //       this.isViewerOnly =
  //       memberAccessData.isViewOnly && !memberAccessData.isSubmitAccess;
  //         this.loadData();
  //       });
  //   }
  // }

  setViewMode(viewMode: ViewMode): void {
    this.viewMode = viewMode;
    if (viewMode === ViewMode.APPROVED) {
      this.studyFacade.updateStudySelectedTab(4);
    } else if (viewMode === ViewMode.IN_REVIEW) {
      this.studyFacade.updateStudySelectedTab(3);
    } else if (viewMode === ViewMode.UPLOAD) {
      this.studyFacade.updateStudySelectedTab(1);
    }
    this.onChangeTab.emit(viewMode);
  }

  private loadData(): void {
    this.activeSaleHorseStudy$
      .pipe(
        filter((study) => !!study),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((study) => {
        this.sale = study.sale;
        this.horse = study.saleHorse;
        if (!this.hasSaleSettings) {
          if (!!study.saleId && !!this.horse) {
            this.studyFacade.loadSaleSettings(
              study.saleId,
              this.horse?.horseId
            );
            this.hasSaleSettings = true;
          }
        }

        if (!this.calledMemberAccess) {
          this.saleFacade.loadSaleMemberAccess(
            study.saleId,
            this.horse?.horseId
          );
          this.calledMemberAccess = true;
        }
      });

    this.attachEvents();
  }

  closeModal(): void {
    this.closedClicked.emit();
  }
}
